import { defineMessages } from 'react-intl'

export default defineMessages({
  title: {
    id: 'containers.OrderPage.components.OverviewPage.components.ActionsMenuFragments.components.AutoDeliver.title',
    defaultMessage: 'Auto deliver',
  },
  confirm: {
    id: 'containers.OrderPage.components.OverviewPage.components.ActionsMenuFragments.components.AutoDeliver.confirm',
    defaultMessage: 'Are you sure? This is non-reversible, and will affect ALL tasks.',
  },
  success: {
    id: 'containers.OrderPage.components.OverviewPage.components.ActionsMenuFragments.components.AutoDeliver.success',
    defaultMessage: 'Auto delivery set up for the order and all current tasks.',
  },
  error: {
    id: 'containers.OrderPage.components.OverviewPage.components.ActionsMenuFragments.components.AutoDeliver.error',
    defaultMessage: 'Auto delivery could not be set up.',
  }
})
